import { Injectable, ViewContainerRef, TemplateRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class SideNavService {
  public panel: MatSidenav;
  private vcf: ViewContainerRef;

  constructor() {}

  setPanel(sidenav: MatSidenav) {
    this.panel = sidenav;
  }

  setContentVcf(viewContainerRef: ViewContainerRef) {
    this.vcf = viewContainerRef;
  }

  private createView(template: TemplateRef<any>) {
    this.vcf.clear();
    this.vcf.createEmbeddedView(template);
  }

  open(template: TemplateRef<any>) {
    document.getElementsByTagName('body')[0].classList.add('open-nav')
    this.createView(template);
    return this.panel.open();
  }

  close() {
    document.getElementsByTagName('body')[0].classList.remove('open-nav')
    document.querySelectorAll('.category-item').forEach(item => item.classList.remove('selected'));
    return this.panel.close();
  }

  toggle() {
    return this.panel.toggle();
  }
}
